import { keyframes as je } from "@emotion/css";
var rr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function tr(e) {
  if (e.__esModule) return e;
  var l = e.default;
  if (typeof l == "function") {
    var s = function i() {
      return this instanceof i ? Reflect.construct(l, arguments, this.constructor) : l.apply(this, arguments);
    };
    s.prototype = l.prototype;
  } else s = {};
  return Object.defineProperty(s, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var h = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(s, i, h.get ? h : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), s;
}
function Ye(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $e = { exports: {} }, k = $e.exports = {}, z, U;
function ge() {
  throw new Error("setTimeout has not been defined");
}
function Ee() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? z = setTimeout : z = ge;
  } catch {
    z = ge;
  }
  try {
    typeof clearTimeout == "function" ? U = clearTimeout : U = Ee;
  } catch {
    U = Ee;
  }
})();
function De(e) {
  if (z === setTimeout)
    return setTimeout(e, 0);
  if ((z === ge || !z) && setTimeout)
    return z = setTimeout, setTimeout(e, 0);
  try {
    return z(e, 0);
  } catch {
    try {
      return z.call(null, e, 0);
    } catch {
      return z.call(this, e, 0);
    }
  }
}
function We(e) {
  if (U === clearTimeout)
    return clearTimeout(e);
  if ((U === Ee || !U) && clearTimeout)
    return U = clearTimeout, clearTimeout(e);
  try {
    return U(e);
  } catch {
    try {
      return U.call(null, e);
    } catch {
      return U.call(this, e);
    }
  }
}
var G = [], X = !1, Z, ae = -1;
function ze() {
  !X || !Z || (X = !1, Z.length ? G = Z.concat(G) : ae = -1, G.length && Be());
}
function Be() {
  if (!X) {
    var e = De(ze);
    X = !0;
    for (var l = G.length; l; ) {
      for (Z = G, G = []; ++ae < l; )
        Z && Z[ae].run();
      ae = -1, l = G.length;
    }
    Z = null, X = !1, We(e);
  }
}
k.nextTick = function(e) {
  var l = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var s = 1; s < arguments.length; s++)
      l[s - 1] = arguments[s];
  G.push(new Ie(e, l)), G.length === 1 && !X && De(Be);
};
function Ie(e, l) {
  this.fun = e, this.array = l;
}
Ie.prototype.run = function() {
  this.fun.apply(null, this.array);
};
k.title = "browser";
k.browser = !0;
k.env = {};
k.argv = [];
k.version = "";
k.versions = {};
function H() {
}
k.on = H;
k.addListener = H;
k.once = H;
k.off = H;
k.removeListener = H;
k.removeAllListeners = H;
k.emit = H;
k.prependListener = H;
k.prependOnceListener = H;
k.listeners = function(e) {
  return [];
};
k.binding = function(e) {
  throw new Error("process.binding is not supported");
};
k.cwd = function() {
  return "/";
};
k.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
k.umask = function() {
  return 0;
};
var Ue = $e.exports;
const L = /* @__PURE__ */ Ye(Ue);
var Te = { exports: {} }, ne = { exports: {} }, w = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pe;
function Ge() {
  if (Pe) return w;
  Pe = 1;
  var e = typeof Symbol == "function" && Symbol.for, l = e ? Symbol.for("react.element") : 60103, s = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, h = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, O = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, x = e ? Symbol.for("react.async_mode") : 60111, P = e ? Symbol.for("react.concurrent_mode") : 60111, T = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, F = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, M = e ? Symbol.for("react.responder") : 60118, K = e ? Symbol.for("react.scope") : 60119;
  function $(n) {
    if (typeof n == "object" && n !== null) {
      var N = n.$$typeof;
      switch (N) {
        case l:
          switch (n = n.type, n) {
            case x:
            case P:
            case i:
            case u:
            case h:
            case A:
              return n;
            default:
              switch (n = n && n.$$typeof, n) {
                case d:
                case T:
                case I:
                case R:
                case O:
                  return n;
                default:
                  return N;
              }
          }
        case s:
          return N;
      }
    }
  }
  function j(n) {
    return $(n) === P;
  }
  return w.AsyncMode = x, w.ConcurrentMode = P, w.ContextConsumer = d, w.ContextProvider = O, w.Element = l, w.ForwardRef = T, w.Fragment = i, w.Lazy = I, w.Memo = R, w.Portal = s, w.Profiler = u, w.StrictMode = h, w.Suspense = A, w.isAsyncMode = function(n) {
    return j(n) || $(n) === x;
  }, w.isConcurrentMode = j, w.isContextConsumer = function(n) {
    return $(n) === d;
  }, w.isContextProvider = function(n) {
    return $(n) === O;
  }, w.isElement = function(n) {
    return typeof n == "object" && n !== null && n.$$typeof === l;
  }, w.isForwardRef = function(n) {
    return $(n) === T;
  }, w.isFragment = function(n) {
    return $(n) === i;
  }, w.isLazy = function(n) {
    return $(n) === I;
  }, w.isMemo = function(n) {
    return $(n) === R;
  }, w.isPortal = function(n) {
    return $(n) === s;
  }, w.isProfiler = function(n) {
    return $(n) === u;
  }, w.isStrictMode = function(n) {
    return $(n) === h;
  }, w.isSuspense = function(n) {
    return $(n) === A;
  }, w.isValidElementType = function(n) {
    return typeof n == "string" || typeof n == "function" || n === i || n === P || n === u || n === h || n === A || n === F || typeof n == "object" && n !== null && (n.$$typeof === I || n.$$typeof === R || n.$$typeof === O || n.$$typeof === d || n.$$typeof === T || n.$$typeof === D || n.$$typeof === M || n.$$typeof === K || n.$$typeof === _);
  }, w.typeOf = $, w;
}
var C = {}, Se;
function He() {
  return Se || (Se = 1, L.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, l = e ? Symbol.for("react.element") : 60103, s = e ? Symbol.for("react.portal") : 60106, i = e ? Symbol.for("react.fragment") : 60107, h = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, O = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, x = e ? Symbol.for("react.async_mode") : 60111, P = e ? Symbol.for("react.concurrent_mode") : 60111, T = e ? Symbol.for("react.forward_ref") : 60112, A = e ? Symbol.for("react.suspense") : 60113, F = e ? Symbol.for("react.suspense_list") : 60120, R = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, M = e ? Symbol.for("react.responder") : 60118, K = e ? Symbol.for("react.scope") : 60119;
    function $(t) {
      return typeof t == "string" || typeof t == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      t === i || t === P || t === u || t === h || t === A || t === F || typeof t == "object" && t !== null && (t.$$typeof === I || t.$$typeof === R || t.$$typeof === O || t.$$typeof === d || t.$$typeof === T || t.$$typeof === D || t.$$typeof === M || t.$$typeof === K || t.$$typeof === _);
    }
    function j(t) {
      if (typeof t == "object" && t !== null) {
        var Y = t.$$typeof;
        switch (Y) {
          case l:
            var te = t.type;
            switch (te) {
              case x:
              case P:
              case i:
              case u:
              case h:
              case A:
                return te;
              default:
                var Ce = te && te.$$typeof;
                switch (Ce) {
                  case d:
                  case T:
                  case I:
                  case R:
                  case O:
                    return Ce;
                  default:
                    return Y;
                }
            }
          case s:
            return Y;
        }
      }
    }
    var n = x, N = P, oe = d, ie = O, se = l, ue = T, ee = i, ce = I, fe = R, J = s, le = u, q = h, V = A, re = !1;
    function de(t) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), r(t) || j(t) === x;
    }
    function r(t) {
      return j(t) === P;
    }
    function a(t) {
      return j(t) === d;
    }
    function m(t) {
      return j(t) === O;
    }
    function y(t) {
      return typeof t == "object" && t !== null && t.$$typeof === l;
    }
    function c(t) {
      return j(t) === T;
    }
    function b(t) {
      return j(t) === i;
    }
    function p(t) {
      return j(t) === I;
    }
    function v(t) {
      return j(t) === R;
    }
    function g(t) {
      return j(t) === s;
    }
    function S(t) {
      return j(t) === u;
    }
    function E(t) {
      return j(t) === h;
    }
    function B(t) {
      return j(t) === A;
    }
    C.AsyncMode = n, C.ConcurrentMode = N, C.ContextConsumer = oe, C.ContextProvider = ie, C.Element = se, C.ForwardRef = ue, C.Fragment = ee, C.Lazy = ce, C.Memo = fe, C.Portal = J, C.Profiler = le, C.StrictMode = q, C.Suspense = V, C.isAsyncMode = de, C.isConcurrentMode = r, C.isContextConsumer = a, C.isContextProvider = m, C.isElement = y, C.isForwardRef = c, C.isFragment = b, C.isLazy = p, C.isMemo = v, C.isPortal = g, C.isProfiler = S, C.isStrictMode = E, C.isSuspense = B, C.isValidElementType = $, C.typeOf = j;
  }()), C;
}
var Ae;
function Me() {
  return Ae || (Ae = 1, L.env.NODE_ENV === "production" ? ne.exports = Ge() : ne.exports = He()), ne.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var pe, Oe;
function Ne() {
  if (Oe) return pe;
  Oe = 1;
  var e = Object.getOwnPropertySymbols, l = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
  function i(u) {
    if (u == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(u);
  }
  function h() {
    try {
      if (!Object.assign)
        return !1;
      var u = new String("abc");
      if (u[5] = "de", Object.getOwnPropertyNames(u)[0] === "5")
        return !1;
      for (var O = {}, d = 0; d < 10; d++)
        O["_" + String.fromCharCode(d)] = d;
      var x = Object.getOwnPropertyNames(O).map(function(T) {
        return O[T];
      });
      if (x.join("") !== "0123456789")
        return !1;
      var P = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(T) {
        P[T] = T;
      }), Object.keys(Object.assign({}, P)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return pe = h() ? Object.assign : function(u, O) {
    for (var d, x = i(u), P, T = 1; T < arguments.length; T++) {
      d = Object(arguments[T]);
      for (var A in d)
        l.call(d, A) && (x[A] = d[A]);
      if (e) {
        P = e(d);
        for (var F = 0; F < P.length; F++)
          s.call(d, P[F]) && (x[P[F]] = d[P[F]]);
      }
    }
    return x;
  }, pe;
}
var ye, xe;
function we() {
  if (xe) return ye;
  xe = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ye = e, ye;
}
var ve, _e;
function Le() {
  return _e || (_e = 1, ve = Function.call.bind(Object.prototype.hasOwnProperty)), ve;
}
var me, ke;
function Ve() {
  if (ke) return me;
  ke = 1;
  var e = function() {
  };
  if (L.env.NODE_ENV !== "production") {
    var l = we(), s = {}, i = Le();
    e = function(u) {
      var O = "Warning: " + u;
      typeof console < "u" && console.error(O);
      try {
        throw new Error(O);
      } catch {
      }
    };
  }
  function h(u, O, d, x, P) {
    if (L.env.NODE_ENV !== "production") {
      for (var T in u)
        if (i(u, T)) {
          var A;
          try {
            if (typeof u[T] != "function") {
              var F = Error(
                (x || "React class") + ": " + d + " type `" + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof u[T] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw F.name = "Invariant Violation", F;
            }
            A = u[T](O, T, x, d, null, l);
          } catch (I) {
            A = I;
          }
          if (A && !(A instanceof Error) && e(
            (x || "React class") + ": type specification of " + d + " `" + T + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof A + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), A instanceof Error && !(A.message in s)) {
            s[A.message] = !0;
            var R = P ? P() : "";
            e(
              "Failed " + d + " type: " + A.message + (R ?? "")
            );
          }
        }
    }
  }
  return h.resetWarningCache = function() {
    L.env.NODE_ENV !== "production" && (s = {});
  }, me = h, me;
}
var he, Fe;
function Ze() {
  if (Fe) return he;
  Fe = 1;
  var e = Me(), l = Ne(), s = we(), i = Le(), h = Ve(), u = function() {
  };
  L.env.NODE_ENV !== "production" && (u = function(d) {
    var x = "Warning: " + d;
    typeof console < "u" && console.error(x);
    try {
      throw new Error(x);
    } catch {
    }
  });
  function O() {
    return null;
  }
  return he = function(d, x) {
    var P = typeof Symbol == "function" && Symbol.iterator, T = "@@iterator";
    function A(r) {
      var a = r && (P && r[P] || r[T]);
      if (typeof a == "function")
        return a;
    }
    var F = "<<anonymous>>", R = {
      array: M("array"),
      bigint: M("bigint"),
      bool: M("boolean"),
      func: M("function"),
      number: M("number"),
      object: M("object"),
      string: M("string"),
      symbol: M("symbol"),
      any: K(),
      arrayOf: $,
      element: j(),
      elementType: n(),
      instanceOf: N,
      node: ue(),
      objectOf: ie,
      oneOf: oe,
      oneOfType: se,
      shape: ce,
      exact: fe
    };
    function I(r, a) {
      return r === a ? r !== 0 || 1 / r === 1 / a : r !== r && a !== a;
    }
    function _(r, a) {
      this.message = r, this.data = a && typeof a == "object" ? a : {}, this.stack = "";
    }
    _.prototype = Error.prototype;
    function D(r) {
      if (L.env.NODE_ENV !== "production")
        var a = {}, m = 0;
      function y(b, p, v, g, S, E, B) {
        if (g = g || F, E = E || v, B !== s) {
          if (x) {
            var t = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw t.name = "Invariant Violation", t;
          } else if (L.env.NODE_ENV !== "production" && typeof console < "u") {
            var Y = g + ":" + v;
            !a[Y] && // Avoid spamming the console because they are often not actionable except for lib authors
            m < 3 && (u(
              "You are manually calling a React.PropTypes validation function for the `" + E + "` prop on `" + g + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), a[Y] = !0, m++);
          }
        }
        return p[v] == null ? b ? p[v] === null ? new _("The " + S + " `" + E + "` is marked as required " + ("in `" + g + "`, but its value is `null`.")) : new _("The " + S + " `" + E + "` is marked as required in " + ("`" + g + "`, but its value is `undefined`.")) : null : r(p, v, g, S, E);
      }
      var c = y.bind(null, !1);
      return c.isRequired = y.bind(null, !0), c;
    }
    function M(r) {
      function a(m, y, c, b, p, v) {
        var g = m[y], S = q(g);
        if (S !== r) {
          var E = V(g);
          return new _(
            "Invalid " + b + " `" + p + "` of type " + ("`" + E + "` supplied to `" + c + "`, expected ") + ("`" + r + "`."),
            { expectedType: r }
          );
        }
        return null;
      }
      return D(a);
    }
    function K() {
      return D(O);
    }
    function $(r) {
      function a(m, y, c, b, p) {
        if (typeof r != "function")
          return new _("Property `" + p + "` of component `" + c + "` has invalid PropType notation inside arrayOf.");
        var v = m[y];
        if (!Array.isArray(v)) {
          var g = q(v);
          return new _("Invalid " + b + " `" + p + "` of type " + ("`" + g + "` supplied to `" + c + "`, expected an array."));
        }
        for (var S = 0; S < v.length; S++) {
          var E = r(v, S, c, b, p + "[" + S + "]", s);
          if (E instanceof Error)
            return E;
        }
        return null;
      }
      return D(a);
    }
    function j() {
      function r(a, m, y, c, b) {
        var p = a[m];
        if (!d(p)) {
          var v = q(p);
          return new _("Invalid " + c + " `" + b + "` of type " + ("`" + v + "` supplied to `" + y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(r);
    }
    function n() {
      function r(a, m, y, c, b) {
        var p = a[m];
        if (!e.isValidElementType(p)) {
          var v = q(p);
          return new _("Invalid " + c + " `" + b + "` of type " + ("`" + v + "` supplied to `" + y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(r);
    }
    function N(r) {
      function a(m, y, c, b, p) {
        if (!(m[y] instanceof r)) {
          var v = r.name || F, g = de(m[y]);
          return new _("Invalid " + b + " `" + p + "` of type " + ("`" + g + "` supplied to `" + c + "`, expected ") + ("instance of `" + v + "`."));
        }
        return null;
      }
      return D(a);
    }
    function oe(r) {
      if (!Array.isArray(r))
        return L.env.NODE_ENV !== "production" && (arguments.length > 1 ? u(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : u("Invalid argument supplied to oneOf, expected an array.")), O;
      function a(m, y, c, b, p) {
        for (var v = m[y], g = 0; g < r.length; g++)
          if (I(v, r[g]))
            return null;
        var S = JSON.stringify(r, function(B, t) {
          var Y = V(t);
          return Y === "symbol" ? String(t) : t;
        });
        return new _("Invalid " + b + " `" + p + "` of value `" + String(v) + "` " + ("supplied to `" + c + "`, expected one of " + S + "."));
      }
      return D(a);
    }
    function ie(r) {
      function a(m, y, c, b, p) {
        if (typeof r != "function")
          return new _("Property `" + p + "` of component `" + c + "` has invalid PropType notation inside objectOf.");
        var v = m[y], g = q(v);
        if (g !== "object")
          return new _("Invalid " + b + " `" + p + "` of type " + ("`" + g + "` supplied to `" + c + "`, expected an object."));
        for (var S in v)
          if (i(v, S)) {
            var E = r(v, S, c, b, p + "." + S, s);
            if (E instanceof Error)
              return E;
          }
        return null;
      }
      return D(a);
    }
    function se(r) {
      if (!Array.isArray(r))
        return L.env.NODE_ENV !== "production" && u("Invalid argument supplied to oneOfType, expected an instance of array."), O;
      for (var a = 0; a < r.length; a++) {
        var m = r[a];
        if (typeof m != "function")
          return u(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + re(m) + " at index " + a + "."
          ), O;
      }
      function y(c, b, p, v, g) {
        for (var S = [], E = 0; E < r.length; E++) {
          var B = r[E], t = B(c, b, p, v, g, s);
          if (t == null)
            return null;
          t.data && i(t.data, "expectedType") && S.push(t.data.expectedType);
        }
        var Y = S.length > 0 ? ", expected one of type [" + S.join(", ") + "]" : "";
        return new _("Invalid " + v + " `" + g + "` supplied to " + ("`" + p + "`" + Y + "."));
      }
      return D(y);
    }
    function ue() {
      function r(a, m, y, c, b) {
        return J(a[m]) ? null : new _("Invalid " + c + " `" + b + "` supplied to " + ("`" + y + "`, expected a ReactNode."));
      }
      return D(r);
    }
    function ee(r, a, m, y, c) {
      return new _(
        (r || "React class") + ": " + a + " type `" + m + "." + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + c + "`."
      );
    }
    function ce(r) {
      function a(m, y, c, b, p) {
        var v = m[y], g = q(v);
        if (g !== "object")
          return new _("Invalid " + b + " `" + p + "` of type `" + g + "` " + ("supplied to `" + c + "`, expected `object`."));
        for (var S in r) {
          var E = r[S];
          if (typeof E != "function")
            return ee(c, b, p, S, V(E));
          var B = E(v, S, c, b, p + "." + S, s);
          if (B)
            return B;
        }
        return null;
      }
      return D(a);
    }
    function fe(r) {
      function a(m, y, c, b, p) {
        var v = m[y], g = q(v);
        if (g !== "object")
          return new _("Invalid " + b + " `" + p + "` of type `" + g + "` " + ("supplied to `" + c + "`, expected `object`."));
        var S = l({}, m[y], r);
        for (var E in S) {
          var B = r[E];
          if (i(r, E) && typeof B != "function")
            return ee(c, b, p, E, V(B));
          if (!B)
            return new _(
              "Invalid " + b + " `" + p + "` key `" + E + "` supplied to `" + c + "`.\nBad object: " + JSON.stringify(m[y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(r), null, "  ")
            );
          var t = B(v, E, c, b, p + "." + E, s);
          if (t)
            return t;
        }
        return null;
      }
      return D(a);
    }
    function J(r) {
      switch (typeof r) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !r;
        case "object":
          if (Array.isArray(r))
            return r.every(J);
          if (r === null || d(r))
            return !0;
          var a = A(r);
          if (a) {
            var m = a.call(r), y;
            if (a !== r.entries) {
              for (; !(y = m.next()).done; )
                if (!J(y.value))
                  return !1;
            } else
              for (; !(y = m.next()).done; ) {
                var c = y.value;
                if (c && !J(c[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function le(r, a) {
      return r === "symbol" ? !0 : a ? a["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && a instanceof Symbol : !1;
    }
    function q(r) {
      var a = typeof r;
      return Array.isArray(r) ? "array" : r instanceof RegExp ? "object" : le(a, r) ? "symbol" : a;
    }
    function V(r) {
      if (typeof r > "u" || r === null)
        return "" + r;
      var a = q(r);
      if (a === "object") {
        if (r instanceof Date)
          return "date";
        if (r instanceof RegExp)
          return "regexp";
      }
      return a;
    }
    function re(r) {
      var a = V(r);
      switch (a) {
        case "array":
        case "object":
          return "an " + a;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + a;
        default:
          return a;
      }
    }
    function de(r) {
      return !r.constructor || !r.constructor.name ? F : r.constructor.name;
    }
    return R.checkPropTypes = h, R.resetWarningCache = h.resetWarningCache, R.PropTypes = R, R;
  }, he;
}
var be, Re;
function Je() {
  if (Re) return be;
  Re = 1;
  var e = we();
  function l() {
  }
  function s() {
  }
  return s.resetWarningCache = l, be = function() {
    function i(O, d, x, P, T, A) {
      if (A !== e) {
        var F = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw F.name = "Invariant Violation", F;
      }
    }
    i.isRequired = i;
    function h() {
      return i;
    }
    var u = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: h,
      element: i,
      elementType: i,
      instanceOf: h,
      node: i,
      objectOf: h,
      oneOf: h,
      oneOfType: h,
      shape: h,
      exact: h,
      checkPropTypes: s,
      resetWarningCache: l
    };
    return u.PropTypes = u, u;
  }, be;
}
if (L.env.NODE_ENV !== "production") {
  var Qe = Me(), Xe = !0;
  Te.exports = Ze()(Qe.isElement, Xe);
} else
  Te.exports = Je()();
var Ke = Te.exports;
const nr = /* @__PURE__ */ qe(Ke), ar = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "polygon(0 0, 0 0, 0 0)",
  height: 1,
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: 1,
  whiteSpace: "nowrap"
}, Q = (e, l = 1) => {
  const s = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, i = e.replace(s, (O, d, x, P) => d + d + x + x + P + P), h = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(i), u = h ? {
    r: parseInt(h[1], 16),
    g: parseInt(h[2], 16),
    b: parseInt(h[3], 16)
  } : { r: 0, g: 0, b: 0 };
  return `rgba(${u.r}, ${u.g}, ${u.b}, ${l})`;
}, or = (e, l = "px") => {
  if (!e.length)
    return "0px";
  const s = (i) => Number(i) === 0 || Number(i);
  return e.map((i) => `${i}${s(i) ? l : ""}`).join(" ");
}, ir = (e, l = "min-width") => {
  let s = e;
  return l === "max-width" && (s -= 1), `@media screen and (${l}: ${s}px)`;
}, sr = (e) => window.matchMedia(`(min-width: ${e}px)`).matches, ur = je({
  "0%": { opacity: 0.6 },
  "50%": { opacity: 1 },
  "100%": { opacity: 0.6 }
}), cr = je({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
});
var o = {
  // Base colours
  white: "#FFF",
  black: "#000",
  jumbo: "#7C7C80",
  catskillWhite: "#EEF3F6",
  porcelain: "#F3F4F5",
  athensGray: "#F9FAFB",
  // THEMES
  // Primary
  cornflowerBlue: "#5EA5EE",
  havelockBlue: "#5698DC",
  hawkesBlue: "#E4F0FC",
  mariner: "#2E71C1",
  // Secondary
  amethyst: "#BA69C8",
  wisteria: "#A55AB2",
  whiteLilac: "#F8F0F9",
  affair: "#974CA3",
  // Success
  jungleGreen: "#34B96F",
  eucalyptus: "#2FA765",
  harp: "#E1F1E7",
  seaGreen: "#229053",
  // Warning
  sandyBrown: "#F28F5D",
  burntSienna: "#E88857",
  provincialPink: "#FDF3EE",
  redDamask: "#D77644",
  // Error
  mandy: "#e25c59",
  chestnutRose: "#D05552",
  linen: "#FCEEEE",
  mojo: "#C24441",
  // Legacy
  scooter: "#40aadb",
  pelorous: "#3A99C4",
  whiteIce: "#D9EEF8",
  jellyBean: "#257FA8",
  // Light
  mystic: "#E4EBEF",
  geyser: "#DAE0E4",
  grayChateau: "#A6ACAF",
  scorpion: "#5C5C5C",
  // Dark
  oxfordBlue: "#343951",
  blueZodiac: "#0B1236",
  mischka: "#D3D5DF",
  blackPearl: "#060A22",
  // Tertiary
  froly: "#F96E8D",
  cranberry: "#E55D7B",
  wispPink: "#FCE6EA",
  cabaret: "#D54F6D",
  // Info
  shakespeare: "#41BFCB",
  bostonBlue: "#30A4AF",
  iceberg: "#D8F2F4",
  easternBlue: "#238F99"
}, W = {
  secondary: {
    base: o.amethyst,
    medium: o.wisteria,
    light: o.whiteLilac,
    dark: o.affair
  },
  success: {
    base: o.jungleGreen,
    medium: o.eucalyptus,
    light: o.harp,
    dark: o.seaGreen
  },
  warning: {
    base: o.sandyBrown,
    medium: o.burntSienna,
    light: o.provincialPink,
    dark: o.redDamask
  },
  error: {
    base: o.mandy,
    medium: o.chestnutRose,
    light: o.linen,
    dark: o.mojo
  },
  legacy: {
    base: o.scooter,
    medium: o.pelorous,
    light: o.whiteIce,
    dark: o.jellyBean
  },
  light: {
    base: o.grayChateau,
    medium: o.geyser,
    light: o.mystic,
    dark: o.scorpion
  },
  dark: {
    base: o.oxfordBlue,
    medium: o.blueZodiac,
    light: o.mischka,
    dark: o.blackPearl
  },
  tertiary: {
    base: o.froly,
    medium: o.cranberry,
    light: o.wispPink,
    dark: o.cabaret
  },
  info: {
    base: o.shakespeare,
    medium: o.bostonBlue,
    light: o.iceberg,
    dark: o.easternBlue
  },
  primary: {
    base: o.cornflowerBlue,
    medium: o.havelockBlue,
    light: o.hawkesBlue,
    dark: o.mariner
  }
};
const fr = {
  backgroundImage: `linear-gradient(${o.white}, ${Q(o.white, 0)}),
    linear-gradient(to top, ${o.white}, ${Q(o.white, 0)}),
    linear-gradient(${Q(o.grayChateau, 0.15)}, ${Q(o.grayChateau, 0)}),
    linear-gradient(to top, ${Q(o.grayChateau, 0.15)}, ${Q(o.grayChateau, 0)})`,
  backgroundPosition: "0 0, 0 100%, 0 0, 0 100%",
  backgroundSize: "100% 50px, 100% 50px, 100% 20px, 100% 20px",
  backgroundRepeat: "no-repeat",
  backgroundColor: o.white,
  backgroundAttachment: "local, local, scroll, scroll"
}, lr = (e = "primary") => {
  switch (e) {
    case "secondary":
      return W.secondary;
    case "success":
      return W.success;
    case "warning":
      return W.warning;
    case "error":
      return W.error;
    case "legacy":
      return W.legacy;
    case "light":
      return W.light;
    case "dark":
      return W.dark;
    case "tertiary":
      return W.tertiary;
    case "info":
      return W.info;
    default:
      return W.primary;
  }
}, dr = (e) => {
  switch (e) {
    case "dark":
      return o.geyser;
    default:
      return o.mystic;
  }
};
var pr = {
  extraLarge: 100,
  medium: 4,
  default: 3,
  small: 2
}, yr = {
  phone: 640,
  // Need to use 821 because of rails. Change back to tablet: 800 when we remove sass
  tablet: 821,
  desktop: 1128
}, vr = {
  heading: '"proxima-nova", Helvetica, Arial, sans-serif',
  body: '"proxima-nova", Helvetica, Arial, sans-serif'
}, mr = {
  extraLarge: 30,
  large: 24,
  medium: 18,
  default: 16,
  small: 14,
  extraSmall: 12
}, hr = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900
}, br = {
  default: 1.2
}, gr = {
  navbar: 50,
  attachmentHeightSmall: 30,
  attachmentHeightDefault: 35
}, Er = {
  extraLarge: 40,
  large: 24,
  medium: 18,
  default: 12,
  small: 6,
  extraSmall: 3
}, Tr = {
  level1: 100,
  level2: 200,
  level3: 300,
  level4: 400,
  level5: 500,
  level6: 600,
  level7: 700,
  level8: 800,
  level9: 900,
  level10: 1e3
}, f = {
  // Base colours
  white: "#FFF",
  black: "#000",
  jumbo: "#7C7C80",
  catskillWhite: "#EEF3F6",
  porcelain: "#F3F4F5",
  athensGray: "#F9FAFB",
  // THEMES
  // Primary
  cornflowerBlue: "#5EA5EE",
  havelockBlue: "#5698DC",
  hawkesBlue: "#E4F0FC",
  mariner: "#2E71C1",
  // Secondary
  amethyst: "#BA69C8",
  wisteria: "#A55AB2",
  whiteLilac: "#F8F0F9",
  affair: "#974CA3",
  // Success
  jungleGreen: "#34B96F",
  eucalyptus: "#2FA765",
  harp: "#E1F1E7",
  seaGreen: "#229053",
  // Warning
  sandyBrown: "#F28F5D",
  burntSienna: "#E88857",
  provincialPink: "#FDF3EE",
  redDamask: "#D77644",
  // Error
  mandy: "#e25c59",
  chestnutRose: "#D05552",
  linen: "#FCEEEE",
  mojo: "#C24441",
  // Legacy
  scooter: "#40aadb",
  pelorous: "#3A99C4",
  whiteIce: "#D9EEF8",
  jellyBean: "#257FA8",
  // Light
  mystic: "#E4EBEF",
  geyser: "#DAE0E4",
  grayChateau: "#A6ACAF",
  scorpion: "#5C5C5C",
  // Dark
  oxfordBlue: "#343951",
  blueZodiac: "#0B1236",
  mischka: "#D3D5DF",
  blackPearl: "#060A22",
  // Tertiary
  froly: "#F96E8D",
  cranberry: "#E55D7B",
  wispPink: "#FCE6EA",
  cabaret: "#D54F6D",
  // Info
  shakespeare: "#41BFCB",
  bostonBlue: "#30A4AF",
  iceberg: "#D8F2F4",
  easternBlue: "#238F99"
};
f.amethyst, f.wisteria, f.whiteLilac, f.affair, f.jungleGreen, f.eucalyptus, f.harp, f.seaGreen, f.sandyBrown, f.burntSienna, f.provincialPink, f.redDamask, f.mandy, f.chestnutRose, f.linen, f.mojo, f.scooter, f.pelorous, f.whiteIce, f.jellyBean, f.grayChateau, f.geyser, f.mystic, f.scorpion, f.oxfordBlue, f.blueZodiac, f.mischka, f.blackPearl, f.froly, f.cranberry, f.wispPink, f.cabaret, f.shakespeare, f.bostonBlue, f.iceberg, f.easternBlue, f.cornflowerBlue, f.havelockBlue, f.hawkesBlue, f.mariner;
export {
  lr as B,
  dr as C,
  ur as F,
  nr as P,
  hr as a,
  mr as b,
  f as c,
  pr as d,
  ir as e,
  vr as f,
  qe as g,
  yr as h,
  Ke as i,
  fr as j,
  L as k,
  br as l,
  tr as m,
  rr as n,
  Q as o,
  ar as p,
  sr as q,
  gr as r,
  Er as s,
  cr as w,
  or as y,
  Tr as z
};
